import { render, staticRenderFns } from "./EstadoIntegraciones.vue?vue&type=template&id=c24cff8c&scoped=true&"
import script from "./EstadoIntegraciones.vue?vue&type=script&lang=ts&"
export * from "./EstadoIntegraciones.vue?vue&type=script&lang=ts&"
import style0 from "./EstadoIntegraciones.vue?vue&type=style&index=0&id=c24cff8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24cff8c",
  null
  
)

export default component.exports